<template>
	<div>
		<v-flex>
			<v-card class="card-inner-wrapper-organisation">
				<div class="card-image">
					<img :src="logoUrl" alt />

					<div
						class="section-status"
						:style="{
							backgroundColor: getStatusColor(
								card_element.periodStatus
							),
						}"
					>
						{{ card_element.periodStatus }}
					</div>
				</div>

				<div class="d-flex flex-row justify-space-between">
					<div class="card-title">
						{{ card_element.name }}
					</div>
				</div>
			</v-card>
		</v-flex>
	</div>
</template>

<script>
import { BASE_URL } from "@/config/api/url/urls_in_app";
export default {
	props: {
		card_element: {
			type: Object,
			required: true,
		},
	},
	computed: {
		logoUrl() {
			if (this.card_element.logo) {
				// Return the actual banner URL if it exists
				return BASE_URL + this.card_element.logo;
			} else {
				// Return the placeholder image URL if the banner doesn't exist
				return require("../../../assets/img/placeholder.png");
			}
		},
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getStatusColor(periodStatus) {
			switch (periodStatus) {
				case "Past":
					return "rgb(222, 161, 40)"; // Orange in RGB
				case "On-going":
					return "rgb(82, 161, 90)"; // Green in RGB
				case "Upcoming":
					return "rgb(35, 86, 194)"; // Blue in RGB
				default:
					return "rgb(117, 117, 177)"; // Gray in RGB
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.flex {
	height: 100%;
	.card-inner-wrapper-organisation {
		background-color: white;
		box-shadow: none;

		display: flex;
		justify-content: flex-start;

		flex-direction: column;
		height: 100%;
		.card-image {
			width: 100%;
			position: relative; /* Make the container relative for absolute positioning */
			img {
				width: 100%;
				max-height: 220px;
				height: 100%;
				object-fit: cover;
			}
			.section-status {
				position: absolute;
				top: 10px; /* Adjust as needed */
				right: 10px; /* Adjust as needed */
				font-size: 14px;
				font-weight: 600;
				padding: 4px 10px;
				color: white;
				border-radius: 8px;
				z-index: 1; /* Ensure it's above the image */
			}
		}
		.card-title {
			font-size: 16px;
			font-weight: 800;
			letter-spacing: 0.3px;
			color: #2b2b2b;
			line-height: 1.2;
			padding: 5px 10px;
		}
	}
}
</style>
